import { DEFAULT_SCREEN_SIZE, SCREEN_SIZE } from "../config";
import { Breakpoint, Screen } from "../types";

const getCurrentScreenSize = (screen: Screen): Breakpoint => {
  if (!screen) {
    return DEFAULT_SCREEN_SIZE;
  }

  const screenSizeProps = Object.keys(SCREEN_SIZE) as Breakpoint[];

  const size = (Object.keys(screen) as Breakpoint[])
    .filter((prop) => screenSizeProps.includes(prop))
    .filter((prop) => screen[prop] === true);

  return size[0] || DEFAULT_SCREEN_SIZE;
};

export { getCurrentScreenSize };
